
app.filter('addTargetBlank', function () {
  return function (x) {
    const tree = angular.element('<div>' + x + '</div>');//defensively wrap in a div to avoid 'invalid html' exception
    tree.find('a').attr('target', '_blank'); //manipulate the parse tree
    return angular.element('<div>').append(tree).html(); //trick to have a string representation
  };
});
